<div class="p-4 flex flex-col gap-y-4 basis-full flex-grow app-full-height">
  <h1>Outstanding Balance Report</h1>

  <form [formGroup]="reportForm" (ngSubmit)="getDockets()" #formContainer>
    <div class="flex flex-col md:flex-row">
      <div class="flex basis-full flex-shrink">
        <report-criteria
          [availableCriteria]="availableCriteria"
          [criteriaForm]="reportForm"
          fxFlex="100"
        ></report-criteria>
      </div>
      <div
        class="flex flex-col justify-start md:items-end items-stretch md:space-y-2"
      >
        <div class="flex flex-row">
          <button
            mat-flat-button
            color="primary"
            id="generate-report"
            [disabled]="!reportForm.valid"
          >
            Generate
          </button>
          <button
            type="button"
            (click)="getDockets(true)"
            mat-flat-button
            id="export-report"
            [disabled]="!reportForm.valid"
          >
            Export
          </button>
        </div>
        <order-by
          [columns]="orderByCols"
          (orderChanged)="setOrderBy($event)"
        ></order-by>
      </div>
    </div>
  </form>

  <div class="flex flex-row basis-full flex-grow">
    <ag-grid-angular
      #agGrid
      [ngStyle]="{ 'height.%': 100, 'width.%': '100' }"
      class="ag-theme-alpine"
      [columnDefs]="columns"
      [gridOptions]="gridOptions"
    ></ag-grid-angular>
  </div>
</div>
